import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { offers } from '../../data/content';
export function OfferIndex() {
  return <section aria-labelledby="offers-title" className="w-full bg-paper text-ink" data-id="element-99" data-mp="23wvweuxid07a">
      <div className="mx-auto max-w-7xl px-5 py-24 md:px-10 lg:py-32" data-id="element-100" data-mp="23urtaf7fo582">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12 lg:items-end" data-id="element-101" data-mp="1zvsjoharbkaa">
          <h2 id="offers-title" className="font-serif text-5xl leading-[1.02] tracking-tight md:text-6xl lg:col-span-7" data-id="element-102" data-mp="1c6rinf497bf1">
            Drie manieren om samen muziek te maken.
          </h2>
          <p className="max-w-md text-lg leading-relaxed text-ink/70 lg:col-span-4 lg:col-start-9" data-id="element-103" data-mp="1ky9wvkhn3h5h">
            Op het podium, aan de piano thuis of met een hele groep op de ukelele. Altijd met hetzelfde doel: plezier in muziek.
          </p>
        </div>

        <ul className="mt-16 border-t border-ink/15" data-id="element-104" data-mp="sfmisp1292dw">
          {offers.map(offer => <li key={offer.to} className="border-b border-ink/15" data-id="element-105" data-mp="oe18nbfwv27e">
              <Link to={offer.to} className="group grid grid-cols-1 items-center gap-6 py-8 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-deep md:grid-cols-12 md:gap-8" data-id="element-106" data-mp="1gzhuxp096lce">
                <div className="overflow-hidden rounded-sm md:col-span-3" data-id="element-107" data-mp="1qs5o89s0y76d">
                  <img src={offer.image} alt="" style={{
                objectPosition: offer.imagePosition
              }} className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-108" data-mp="1vomgng69b7p9" />
                </div>
                <div className="md:col-span-6" data-id="element-109" data-mp="181xrc9ex4cym">
                  <h3 className="font-serif text-4xl leading-none transition-colors duration-150 group-hover:text-amber-deep md:text-5xl" data-id="element-110" data-mp="1czpgivo6hkz4">
                    {offer.title}
                  </h3>
                  <p className="mt-4 max-w-lg text-[17px] leading-relaxed text-ink/70" data-id="element-111" data-mp="2ocs1e2xb8wp3">{offer.text}</p>
                </div>
                <div className="flex items-center justify-between gap-4 md:col-span-3 md:justify-end" data-id="element-112" data-mp="oa0mku9nd7mm">
                  <span className="text-sm font-medium text-ink/60" data-id="element-113" data-mp="jc8uo0905lif">{offer.meta}</span>
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-ink/20 transition-colors duration-150 group-hover:border-ink group-hover:bg-ink group-hover:text-paper" data-id="element-114" data-mp="xbqb9sc59sgp">
                    <ArrowUpRightIcon aria-hidden className="h-5 w-5" data-id="element-115" data-mp="5iznm68j1c32" />
                  </span>
                </div>
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}